import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';

dayjs.extend(utc);
dayjs.extend(timezone);

// 设置时间时区:
dayjs.tz.setDefault('Asia/Shanghai');

/**
 * 时间格式化
 * @param date 需要格式化的时间
 * @param format 格式文本
 * @returns
 */
export const timeFormat = (date?: Date | string, format = 'YYYY-MM-DD') => {
  const d = date || new Date();
  return dayjs(d).format(format);
};

// 获取当前的时间对象
export const getNowDate = () => dayjs().toDate();

// 获取年份
export const getYear = () => getNowDate().getFullYear();

/**
 * 获取当前时间戳(毫秒)
 * @returns 当前时间戳, 毫秒
 */
export const getNowTimestamp = () => dayjs().valueOf();

/**
 * 获取当时时间的时间戳, 秒
 * @returns 当前时间(秒)
 */
export const getNow = () => dayjs().unix();

// 比较两个时间的大小
export const compareDate = (
  a: Date | string | number,
  b: Date | string | number
) => {
  const t1 = dayjs(a).toDate()
    .getTime();
  const t2 = dayjs(b).toDate()
    .getTime();
  return t1 >= t2;
};

export const getTime = (v?: string) => {
  if (v) {
    return dayjs(v).unix();
  }
  return getNow();
};
